import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  listFilters: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingVerticalS,
    minHeight: '60px',
    boxSizing: 'border-box',
    padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalM}`,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
  },

  searchControl: {
    flex: 1,
    minWidth: 0,
  },

  tagMenuPopover: {
    maxHeight: 'min(70vh, 480px)',
    overflowY: 'auto',
    overscrollBehavior: 'contain',
  },

  tagHeading: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
    width: '100%',
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
    backgroundColor: tokens.colorNeutralBackground3,
    appearance: 'none',
    borderTopWidth: '0px',
    borderRightWidth: '0px',
    borderBottomWidth: '0px',
    borderLeftWidth: '0px',
    cursor: 'pointer',
    color: tokens.colorNeutralForeground1,
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
    fontFamily: 'inherit',
    textAlign: 'left',
    ':hover': {
      backgroundColor: tokens.colorNeutralBackground3Hover,
    },
    ':focus-visible': {
      outline: `2px solid ${tokens.colorBrandStroke1}`,
    },
  },

  tagChevron: {
    marginLeft: 'auto',
  },

  emptySearch: {
    padding: tokens.spacingHorizontalM,
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase200,
  },

  creationStepLabel: {
    fontStyle: 'italic',
  },

  fullWidthButton: {
    width: '100%',
  },

  createMenuList: {
    width: '320px',
    maxWidth: '320px',
  },

  createMenuItemContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXXS,
    paddingTop: tokens.spacingVerticalXXS,
    paddingBottom: tokens.spacingVerticalXXS,
  },

  createMenuItemTitle: {
    fontWeight: tokens.fontWeightSemibold,
  },

  createMenuItemDescription: {
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase200,
    lineHeight: tokens.lineHeightBase200,
    whiteSpace: 'normal',
  },
});
